export const commonEnv = {
  production: false,
  isPendo: false,
  isLocal: true,
  envName: 'dev',
  agGridLicenseKey: '#{AG_GRID_LICENCE_KEY}#',
  auth0Config: {
    domain: 'auth.dev.cloudmed.com',
    clientId: '#{AUTH0_CLIENT_ID}#',
    audience: 'dev.cloudmed',
    cmaiAudience: 'dev.cloudmed-ai.services',
    redirectUri: window.location.origin + '/callback',
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
  },
  api: {
    contractServiceBaseURL: 'https://cmedevpricingcontractapi.azurewebsites.net/api/',
    ruleEngineServiceBaseURL: 'https://cmedevruleruleengineapi.azurewebsites.net',
    globalServiceBaseURL: 'https://cmedevpricingglobalapi.azurewebsites.net/api/',
    sparkEngineServiceBaseURL: 'https://cmedevrulesparkengapi3.azurewebsites.net/api/',
    userManagementBaseUrl: 'https://cmedevwkdradminapi.azurewebsites.net',
    payerAccountabilityBaseUrl: 'https://cmedevwkdrpayeraccountabilityapi.azurewebsites.net/api',
    ruleManagementServiceBaseURL: 'https://cmedevrulemanagement.azurewebsites.net',
    identificationRuleEngineBaseURL: 'https://cmedevruleidentificationruleengineapi.azurewebsites.net',
    riUserManagementUrl: 'https://usermanagementapi.dev.cloudmed.com',
    dataApiUrl: 'https://riapi.dev.cloudmed.com',
    cmaiContractsPricingWorkflowApi: 'https://cmedevpricingworkflowapi.azurewebsites.net/api',
  },
  cloudMedApiBaseUrls: ['ruleEngineServiceBaseURL', 'userManagementBaseUrl', 'payerAccountabilityBaseUrl'],
  revenueIntelligenceBaseUrls: [
    'contractServiceBaseURL',
    'riUserManagementUrl',
    'globalServiceBaseURL',
    'sparkEngineServiceBaseURL',
    'ruleManagementServiceBaseURL',
    'identificationRuleEngineBaseURL',
    'dataApiUrl',
    'cmaiContractsPricingWorkflowApi',
  ],
  ui: {
    accountInfoURL: 'https://app.dev.cloudmed.com/account-info?id=',
    adminURL: 'https://admin.dev.cloudmed.com/',
    contractsURL: 'https://contracts.dev.cloudmed.com/',
  },
  sa: {
    filesURL: 'https://cmedevrulegensa.z20.web.core.windows.net/',
    execResultBaseURL: 'abfss://identificationengine@cmedevruledl.dfs.core.windows.net',
  },
  applicationId: 2,
  denialsApplicationId: 46,
  applicationName: 'Rules',
  denialsApplicationName: 'Denials',
  applicationGroupName: 'Rules',
  appInsights: {
    instrumentationKey: '#{APP_INSIGHTS_KEY}#',
  },
  denialsEnabled: true,
};
